import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteSupplier, setDeleteSupplierId} from "../../actions/supplier";

const SupplierDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_supplier, currentPage, numberOfPages, suppliers} = useSelector(state => state.supplier);

    const closeModal = () =>{
        // removing supplier user from redux state by sending null setDeleteSupplierId
        dispatch(setDeleteSupplierId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage == numberOfPages) && (suppliers.length == 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteSupplier(delete_supplier.id, getPage))
    };

    let condition = false;
    if(delete_supplier !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Yetkazib beruvchini o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu yetkazib beruvchini o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SupplierDeleteForm;